import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../_services/index';
import { environment } from "src/environments/environment"
 

@Injectable()
export class ExternalRouteGuard  {
  constructor(private router: Router,private authService: AuthService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (!this.authService.userLoggedIn) {
            return true;
        }else if(environment.onPremise && this.authService.isAdmin()){
          this.router.navigate(['/admin/utilisateurs']);
        }
        else if(this.authService.isArchitect() || this.authService.isCollaborateur() || this.authService.isAdmin()){
          this.router.navigate(['/architect/my-consultations']);
        }
        else if(this.authService.isArtisan()){
          this.router.navigate(['/artisan/project-list']);
        }
        else{
          this.router.navigate(['/architecte/my-consultations']);
        }
        return false;
  }
}
